export default __webpack_public_path__ + "static/media/img_16.1b6c5982.JPG";